import React from "react";
import HeroSection from "./HeroSection";
import JoinSection from "./JoinSection";
import FeaturesSection from "../commonComponents/FeaturesSection";
import featuresJson from "../commonComponents/featuresJson";
import styles from "./explore.module.css";
import ExtraFeatures from "./ExtraFeatures";
import Testimonials from "./Testimonials";

const Explore = () => {
  return (
    <>
      <HeroSection />
      <JoinSection />
      <div className="marg_100">
        <FeaturesSection feature={featuresJson[0]} />
      </div>
      <div
        className={`wholeWidthContainer marg_100 ${styles.container}`}
        style={{ background: "#F2F2F2" }}
      >
        <FeaturesSection feature={featuresJson[1]} />
      </div>
      <div className="marg_100">
        <FeaturesSection feature={featuresJson[2]} />
      </div>
      <div
        className={`wholeWidthContainer marg_100 ${styles.container}`}
        style={{ background: "#D0EE11" }}
      >
        <FeaturesSection feature={featuresJson[3]} />
      </div>
      <div className="marg_100">
        <FeaturesSection feature={featuresJson[4]} />
      </div>
      <ExtraFeatures />
      <Testimonials />
    </>
  );
};

export default Explore;
